import React from 'react';
import { Pane, Marker, Tooltip } from 'react-leaflet';
import { useAppSelector } from 'hooks/redux';
import { selectPadsByLandingZoneId } from 'selectors/liveAircraftSelectors';
import { PreviousDropPointIcon } from './MapIcons';

interface LandingPadsLayerProps {
  landingZoneId: string;
}

export const LandingPadsLayer = ({ landingZoneId }: LandingPadsLayerProps) => {
  const landingPads = useAppSelector(state => selectPadsByLandingZoneId(state, landingZoneId));

  if (!landingPads?.length) {
    return null;
  }

  return (
    <>
      {landingPads.map(pad => (
        <Pane
          style={{ zIndex: 9997 }}
          name={'pad ' + pad.id}
          key={`landing-pad-marker-${pad.id}`}>
          <Marker
            position={[pad.latitude, pad.longitude]}
            icon={PreviousDropPointIcon}>
            <Tooltip
              permanent
              direction="bottom"
              opacity={0.6}
              offset={[0, 10]}>
              {pad.name}
            </Tooltip>
          </Marker>
        </Pane>
      ))}
    </>
  );
};


